// extracted by mini-css-extract-plugin
export default {"input":"InputStyles_input__ZCYE3","label":"InputStyles_label__7yJmM"};